/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { AuthState } from "~/features/auth/types";
import { RootState } from "~/state/types";

const getState = (state: RootState) => state.auth;

const createSelector =
  <TSelected = unknown>(selector: (state: AuthState) => TSelected): ((rootState: RootState) => TSelected) =>
  (rootState) =>
    selector(getState(rootState));

export const selectAuthInitialized = createSelector((state) => state.authInitialized);
export const selectAuthViewOnly = createSelector((state) => state.viewOnly);

export const selectAuthAccount = createSelector((state) => state.account);
export const selectAuthResellerId = createSelector((state) => state.account?.resellerId ?? null);
export const selectAuthHasOneClick = createSelector((state) => state.account?.hasOneClick ?? false);
export const selectAuthEmail = createSelector((state) => state.account?.email ?? "");

export const selectLoginStatus = createSelector((state) => state.loginStatus);

export const selectTwoFactorAuthRequired = createSelector((state) => state.twoFactorAuth.required);
export const selectTwoFactorAuthEmailStatus = createSelector((state) => state.twoFactorAuth.emailSendingStatus);
export const selectTwoFactorAuthEmailAddress = createSelector((state) => state.twoFactorAuth.emailSentTo);
export const selectTwoFactorAuthTokenValidationStatus = createSelector(
  (state) => state.twoFactorAuth.tokenValidationStatus,
);
export const selectTwoFactorAuthSessionCheckStatus = createSelector((state) => state.twoFactorAuth.sessionCheckStatus);
export const selectTwoFactorAuthDifferentSession = createSelector((state) => state.twoFactorAuth.differentSession);

export const selectResellerConfig = createSelector((state) => state.account?.config);
